import React, { Component, MouseEvent } from "react";
import "./Menu.css";

interface MenuProps {
  toggleClockView: (Event: MouseEvent) => void;
}

export class Menu extends Component<MenuProps, {}> {
  menuOpenRef: React.RefObject<HTMLInputElement>;
  
  constructor(props: MenuProps) {
    super(props);
    this.menuOpenRef = React.createRef();
  }

  public componentDidMount() {
    console.log(this.menuOpenRef.current);
  }

  render() {
    return <>
      <a href="#" className="close" onClick={this.props.toggleClockView}>
        ✕
      </a>
      <nav className="menu">
        <input
            type="checkbox"
            ref={this.menuOpenRef}
            className="menu-open"
            name="menu-open"
            id="menu-open"
        />
        <label className="menu-open-button" htmlFor="menu-open">
          <span className="lines line-1"/>
          <span className="lines line-2"/>
          <span className="lines line-3"/>
        </label>

        <a href="#" className="menu-item blue">
          <i className="fa fa-anchor"/>🐶
        </a>
        <a href="#" className="menu-item green">
          <i className="fa fa-coffee"/>🐶
        </a>
        <a href="#" className="menu-item red">
          <i className="fa fa-heart"/>🐶
        </a>
        <a href="#" className="menu-item purple">
          <i className="fa fa-microphone"/>🐶
        </a>
        <a href="#" className="menu-item orange">
          <i className="fa fa-star"/>🐶
        </a>
        <a href="#" className="menu-item lightblue">
          <i className="fa fa-diamond"/>🐶
        </a>
      </nav>
    </>;
  }
}

export default Menu;
